export const DEFAULT_CRM_TOKEN = 'xtzolav8oji';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.jpeg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const submitRequestIconUrl = `${window.assetsLocation}/images/request.svg`;
export const loginRequestsIconUrl = `${window.assetsLocation}/images/inbox.svg`;
export const viewAllRequestsIconUrl = `${window.assetsLocation}/images/map.svg`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['3'];
export const faqArticleIds = [
    '5', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '23', '24'
];
